import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Para qué edad está pensado?',
    a: 'Para adultos mayores de 60 años en adelante. Funciona con o sin experiencia previa en actividades cognitivas'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Acceso inmediato después del pago. Podés imprimirlo o usarlo en celular o tablet'
  }, {
    q: '¿Necesita ayuda para usarlo?',
    a: 'No. Está diseñado para que el adulto mayor lo use solo. Aunque también funciona perfecto acompañado'
  }, {
    q: '¿Qué lo diferencia de lo que hay en internet?',
    a: 'Todo el contenido tiene referencias culturales argentinas: mate, tangos, provincias, historia y tradiciones locales'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días con devolución del 100% sin preguntas'
  }, {
    q: '¿Sirve si tiene problemas de memoria?',
    a: 'Sí. Está especialmente diseñado para estimular y ejercitar la memoria de manera progresiva y amigable'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-stone-50" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <div className="text-center mb-12" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 flex items-center justify-center gap-3" data-id="element-62">
            <HelpCircle className="w-8 h-8 text-amber-500" data-id="element-63" />❓ LO QUE MÁS NOS
            PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-stone-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-65">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-66">
                <span className="font-bold text-lg text-slate-800 pr-8" data-id="element-67">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-blue-600 flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-68" />
              </button>
              <AnimatePresence data-id="element-69">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-70">
                    <div className="px-6 pb-5 text-slate-600 leading-relaxed border-t border-stone-100 pt-4" data-id="element-71">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}